import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from '../utils/cn.js';
/**
 * Money display. Always renders in monospace with tabular numerals, with
 * the currency code AFTER the amount in smaller type — Mercury/Roco style.
 *
 * The component is purely presentational: it formats the number, but it
 * does NOT do any FX conversion. Callers must pass the amount already
 * expressed in the target currency.
 */
export function Money({ amountCents, currency, locale, showSign = false, colorBySign = true, className, ...rest }) {
    const major = amountCents / 100;
    const sign = amountCents > 0 ? 'positive' : amountCents < 0 ? 'negative' : 'zero';
    const formatter = new Intl.NumberFormat(locale, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
        signDisplay: showSign && amountCents !== 0 ? 'always' : 'auto',
    });
    return (_jsxs("span", { className: cn('clari-money', colorBySign && sign === 'positive' && 'clari-money--positive', colorBySign && sign === 'negative' && 'clari-money--negative', className), ...rest, children: [_jsx("span", { className: "clari-money__amount", children: formatter.format(major) }), _jsx("span", { className: "clari-money__currency", children: currency })] }));
}
//# sourceMappingURL=Money.js.map